const o = "commons-module_box-container__0I7Uo",
  e = "commons-module_box-title__Brj2C",
  n = "commons-module_box-label__aKGDP",
  t = {
    boxContainer: o,
    boxTitle: e,
    boxLabel: n
  };
export { t as c };